// Central place to manage API endpoints
export const ENDPOINTS = {
  newsletter: {
    subscribe: 'https://adaptm.app.n8n.cloud/webhook/rt-newsletter-submit'
  }
} as const;